import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  createSelectorHook,
  TypedUseSelectorHook,
  useDispatch,
} from "react-redux";
import { StorageAuth } from "../localStorage/StorageAuth";
import { AuthReducer } from "./slices/authSlice";
import { ReducerUI } from "./slices/sliceUI";
import { ReducerMenuByRole } from "./slices/sliceMenuByRole";
import { ReducerSuperAdminTable } from "./slices/superAdminTableSlice";
import { ReducerAdminTable } from "./slices/adminTableSlice";
import { ReducerUserTable } from "./slices/userTableSlice";

const RootReducer = combineReducers({
  auth: AuthReducer,
  ui: ReducerUI,
  menuByRole: ReducerMenuByRole,
  superAdminTable: ReducerSuperAdminTable,
  adminTable: ReducerAdminTable,
  userTable: ReducerUserTable,
});

type ReducerParams = Parameters<typeof RootReducer>;
type ReducerReturn = ReturnType<typeof RootReducer>;

const ActionAppTypeResetStore = "RESET_APP_REDUX_STORE";

export const ActionApp = {
  ResetStore: (): AnyAction => ({ type: ActionAppTypeResetStore }),
};

const AppReducer = (...arg: ReducerParams): ReducerReturn => {
  const [, action] = arg;
  if (action.type === ActionAppTypeResetStore) {
    StorageAuth.Clear();
    return RootReducer(undefined, action);
  }
  return RootReducer(...arg);
};

export const RegAuthAppStore = configureStore({
  reducer: AppReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export type RegAuthAppState = ReturnType<typeof RootReducer>;
export type RegAuthAppDispatch = typeof RegAuthAppStore.dispatch;
export const useAppDispatch = () => useDispatch<RegAuthAppDispatch>();
export const useAppSelector =
  createSelectorHook() as TypedUseSelectorHook<RegAuthAppState>;
